import * as types from '../actions/zoom-actions-types';


const SET_ZOOM_CALL_STATUS_DISPLAY_INITIAL_STATE = {
	isLoading: false,
	callStatus: "",
	error: '',
};

export function setZoomCallStatusDisplayReducer(state = SET_ZOOM_CALL_STATUS_DISPLAY_INITIAL_STATE, action) {
	switch (action.type) {
		case types.SET_ZOOM_CALL_DISPLAY_STATUS:
			return { ...state, isLoading: false, callStatus: action.payload };
		default:
			return state;
	}
}